import type { FC } from "react";

import { Tooltip } from "@/components/Tooltip";

export const OCU: FC<{ label?: string }> = ({ label = "OCU" }) => {
    return (
        <Tooltip
            content={
                <div className="flex max-w-xs flex-col gap-2">
                    <span>Ona Compute Units (OCUs) are credits that cover environment and agent usage.</span>
                    <a
                        href="https://ona.com/pricing#what-is-an-ona-compute-unit-ocu"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline"
                    >
                        Learn more
                    </a>
                </div>
            }
            inverted={false}
            usePortal={true}
        >
            <span className="cursor-help underline decoration-dotted decoration-1 underline-offset-2">{label}</span>
        </Tooltip>
    );
};
export const OCUs: FC = () => {
    return <OCU label="OCUs" />;
};
